import { Navigate } from 'react-router-dom';
import { useCurrentUser } from '../api/auth';
import { OverviewPage } from './dashboard/OverviewPage';

/**
 * მთავარი გვერდი როლის მიხედვით:
 *   ADMIN / MANAGER → მიმოხილვის დეშბორდი
 *   LECTURER        → კალენდარი (მისი სამუშაო ეკრანი — დაგეგმილი ლექციები)
 */
export function DashboardPage() {
  const user = useCurrentUser();
  return user.role === 'LECTURER' ? <Navigate to="/schedule" replace /> : <OverviewPage />;
}
